import Cookies from 'js-cookie';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
};

const mutations = {
  TOGGLE_SIDEBAR: (stateObj) => {
    const states = stateObj;
    states.sidebar.opened = !state.sidebar.opened;
    states.sidebar.withoutAnimation = false;
    if (states.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (stateObj, withoutAnimation) => {
    const states = stateObj;
    Cookies.set('sidebarStatus', 0);
    states.sidebar.opened = false;
    states.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (stateObj, device) => {
    const states = stateObj;
    states.device = device;
  },
  SET_SIZE: (stateObj, size) => {
    const states = stateObj;
    states.size = size;
    Cookies.set('size', size);
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
